  <template>
    <div class="filter-bar ui basic segment grid">
      <div class="simple-search-container">
          <input type="text" v-model="filterText" class="form-control" :placeholder="placeholder">
          <transition name="btn-fade">
             <button class="btn btn-primary simple-search-button" @click="doFilter">Filter</button>
            <!--button class="btn btn-outline-primary simple-search-button" v-if="filterText" @click="resetFilter">Reset</button-->
          </transition>
      </div>
    </div>
  </template>


  <style scoped lang="scss">
    .simple-search-container{
      position: relative;
      max-width: 300px;
    }
    .simple-search-button{
      position: absolute;
      right: 0;
      top: 0;
    }
    .btn-fade-enter-active, .btn-fade-leave-active {
      transition: opacity .5s;
    }
    .btn-fade-enter, .btn-fade-leave-to{
      transition: opacity .5s;
      opacity: 0;
    }
  </style>

  <script>
  export default {
    props:['placeholder'],
    data () {
      return {
        filterText: ''
      }
    },
    methods: {
      doFilter () {
         this.$events.fire('filter-set', this.filterText)
       },
      resetFilter () {
        this.filterText = ''
        this.$events.fire('filter-reset')
      }
    },
  }
</script>
